import type { ISxProps } from '@/CommonComponents/types'
import { Box as MUIBox } from '@mui/material'
interface IBoxProps {
  ref?: React.RefObject<HTMLDivElement | null>
  sx?: ISxProps
  children: React.ReactNode
  onClick?: () => void
}

export default function Box({ sx, children, ref, onClick }: IBoxProps) {
  return (
    <MUIBox sx={sx} ref={ref} onClick={onClick}>
      {children}
    </MUIBox>
  )
}
